import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  CrewMemberTypeRatingSkeleton,
  CrewMemberTypeRatingAudit
} from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-crew-member-type-rating-audit-list',
  templateUrl: './person-profile-crew-member-type-rating-audit-list.component.html',
  styleUrls: ['./person-profile-crew-member-type-rating-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileCrewMemberTypeRatingAuditListComponent implements OnInit {
  @Input() crewMemberTypeRating: CrewMemberTypeRatingSkeleton;
  @Input() loading: boolean;
  @Input() crewMemberTypeRatingAudits: CrewMemberTypeRatingAudit[];

  @Output() loadCrewMemberTypeRatingAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadCrewMemberTypeRatingAudits.emit(this.crewMemberTypeRating.crewMemberTypeRatingId);
  }

  onNextPage() {
    this.nextPage.emit(this.crewMemberTypeRating.crewMemberTypeRatingId);
  }
}
